import { READONLY_TUPLE_PRIVATE } from './privates';
import { ConstructReadonlyTuple } from './constructor';
export function ReadonlyTupleGetLength(instance) {
    return instance[READONLY_TUPLE_PRIVATE].items.length;
}
export function ReadonlyTupleItem(instance, index) {
    const privates = instance[READONLY_TUPLE_PRIVATE];
    if ((0 <= index) && (index < privates.items.length)) {
        return privates.items[index];
    }
    else {
        throw new RangeError(`Index out of range.`);
    }
}
export class ReadonlyTuple {
    constructor(tuple) {
        ConstructReadonlyTuple(this, tuple);
    }
    get length() {
        return ReadonlyTupleGetLength(this);
    }
    item(index) {
        return ReadonlyTupleItem(this, index);
    }
    [Symbol.iterator]() {
        return this[READONLY_TUPLE_PRIVATE].items[Symbol.iterator]();
    }
    toString() {
        return this[READONLY_TUPLE_PRIVATE].items.toString();
    }
    join(separator) {
        return this[READONLY_TUPLE_PRIVATE].items.join(separator);
    }
    indexOf(searchElement, fromIndex) {
        return this[READONLY_TUPLE_PRIVATE].items.indexOf(searchElement, fromIndex);
    }
    lastIndexOf(searchElement, fromIndex) {
        return this[READONLY_TUPLE_PRIVATE].items.lastIndexOf(searchElement, fromIndex);
    }
    includes(searchElement, fromIndex) {
        return this[READONLY_TUPLE_PRIVATE].items.includes(searchElement, fromIndex);
    }
    find(predicate, thisArg = this) {
        return this[READONLY_TUPLE_PRIVATE].items.find(predicate, thisArg);
    }
    findIndex(predicate, thisArg = this) {
        return this[READONLY_TUPLE_PRIVATE].items.findIndex(predicate, thisArg);
    }
}
//# sourceMappingURL=implementation.js.map